import styles from './index.module.css';
import Sense from '../../../assets/images/clientLogos/ape_sense.png';
import Ebis from '../../../assets/images/clientLogos/ebis_logo.png';
import JandA from '../../../assets/images/clientLogos/janda_logo.png';
import MHoldings from '../../../assets/images/clientLogos/mholdings_logo.png';
import Nenasala from '../../../assets/images/clientLogos/nenasala_logo.png';
import NewLeeds from '../../../assets/images/clientLogos/new_leeds.png';
import PCC from '../../../assets/images/clientLogos/pcc_logo.png';
import RDE from '../../../assets/images/clientLogos/rde_logo.png';
import Sathra from '../../../assets/images/clientLogos/sathra_logo.jpg';
import NVC from '../../../assets/images/clientLogos/nvc_logo.png';
import TEBA from '../../../assets/images/clientLogos/eba_logo.png';
import SDTI from '../../../assets/images/clientLogos/sdti_logo.png';
import Letmo from '../../../assets/images/clientLogos/letmo_news.jpg';

const clients = [
    { id: 'sathra', name: 'Sathra', image: Sathra, group: 'ims' },
    { id: 'nenasala', name: 'Nenasala Balangoda', image: Nenasala, group: 'ims' },
    { id: 'new-leeds', name: 'New Leeds', image: NewLeeds, group: 'ims' },
    { id: 'ebis', name: 'EBIS', image: Ebis, group: 'ims' },
    { id: 'apesense', name: 'Apesense', image: Sense, group: 'standalone' },
    { id: 'j-and-a', name: 'J&A', image: JandA, group: 'carxchanger' },
    { id: 'm-holdings', name: 'MHoldings', image: MHoldings, group: 'carxchanger' },
    { id: 'sdti', name: 'SDTI', image: SDTI, group: 'ims' },
    { id: 'letmo', name: 'Letmo', image: Letmo, group: 'standalone' },
    { id: 'pcc', name: 'PCC', image: PCC, group: 'standalone' },
    { id: 'rde', name: 'RDE', image: RDE, group: 'standalone' },
    { id: 'nvc', name: 'NVC', image: NVC, group: 'standalone' },
    { id: 'teba', name: 'TEBA', image: TEBA, group: 'standalone' },
];

const imsClients = clients.filter((client) => client.group === 'ims');
const carExchangerClients = clients.filter((client) => client.group === 'carxchanger');
const standaloneClients = clients.filter((client) => client.group === 'standalone');

const ClientLogo = ({ client }) => (
    <div className={styles.clientLogo}>
        <img src={client.image} alt={`${client.name} logo`} />
    </div>
);

const Clients = () => (
    <section className={styles.clientsSection} aria-labelledby="clients-title">
        <div className="main-container">
            <div className="container-content">
                <div className={styles.expertsSec}>
                    <header className={styles.sectionHeading}>
                        <p className={styles.eyebrow}>Selected work</p>
                        <h2 id="clients-title">Clients &amp; Solutions</h2>
                        <p>Systems built for multiple organizations, alongside independent client engagements.</p>
                    </header>

                    <section className={styles.systemGroup} aria-labelledby="ims-title">
                        <div className={styles.systemIntro}>
                            <div>
                                <p className={styles.groupLabel}>Shared product</p>
                                <h3 id="ims-title">Ardillalabs IMS</h3>
                                <span className={styles.groupLabel}>Simplyfy. Manage. Grow.</span>
                            </div>
                            <span className={`${styles.sampleNote} ${styles.whatsapp}`}> Need a smarter way to manage your institute? <br /> Chat with us on WhatsApp: {" "}
                                <a
                                    className={`${styles.sampleNote} ${styles.whatsappCta}`}
                                    href="https://wa.me/94777634902?text=Hello%20Ardillalabs%2C%20I%27m%20interested%20in%20Ardillalabs%20IMS."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Chat with Ardillalabs about the Institute Management System on WhatsApp"
                                >
                                    +94 77 763 4902
                                </a>
                            </span>
                        </div>

                        <div className={styles.systemDetails}>
                            <article>
                                <p>Ardillalabs IMS helps educational institutes, tuition centers, and training institutes manage daily operations in one place. It keeps records organized and reduces manual work.</p>
                            </article>
                            <article>
                                <h4>Included features</h4>
                                <ul className={styles.featureList}>
                                    <li><strong>Student Management</strong><span>Register students and maintain profiles and records.</span></li>
                                    <li><strong>Teacher Management</strong><span>Manage teacher profiles, classes, and earnings.</span></li>
                                    <li><strong>Class Management</strong><span>Organize classes, teachers, and students.</span></li>
                                    <li><strong>Attendance Management</strong><span>Record and review attendance for each class.</span></li>
                                    <li><strong>Class Payments</strong><span>Record student payments and track payment status.</span></li>
                                    <li><strong>Teacher Earnings &amp; Settlements</strong><span>Calculate class earnings and manage teacher settlements.</span></li>
                                    <li><strong>Reports</strong><span>Review student, attendance, payment, and earnings activity.</span></li>
                                    <li><strong>Income &amp; Expenses</strong><span>Track institute income, expenses, and finances.</span></li>
                                </ul>
                            </article>
                        </div>

                        <div className={styles.groupClients}>
                            <h4>Organizations using the system</h4>
                            <div className={styles.logoGrid}>
                                {imsClients.map((client) => <ClientLogo key={client.id} client={client} />)}
                            </div>
                        </div>
                    </section>

                    <section className={styles.systemGroup} aria-labelledby="ims-title">
                        <div className={styles.systemIntro}>
                            <div>
                                <p className={styles.groupLabel}>Shared product</p>
                                <h3 id="ims-title">CarXChanger</h3>
                            </div>
                            <span className={`${styles.sampleNote} ${styles.whatsapp}`}>Get Your Quote:
                                <a
                                    className={`${styles.sampleNote} ${styles.whatsappCta}`}
                                    href="https://wa.me/94777634902?text=Hello%20Ardillalabs%2C%20I%27m%20interested%20in%20Ardillalabs%20IMS."
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Chat with Ardillalabs about the Vehicle Management System on WhatsApp"
                                >
                                    +94 77 763 4902
                                </a>
                            </span>
                        </div>

                        <div className={styles.systemDetails}>
                            <article>
                                <p>CarXchanger is built exclusively for car dealers, empowering you with all the tools needed to succeed in today’s digital-first world. From managing inventory and tracking orders to showcasing vehicles and engaging customers — it's all streamlined, all connected, all in one place. Boost sales, simplify operations, and deliver a seamless experience that keeps your customers coming back.</p>
                            </article>
                            <article>
                                <h4>Included features</h4>
                                <h4 style={{ marginTop: '10px' }}>For Dealers:</h4>
                                <ul className={styles.featureList}>
                                    <li><strong>Inventory Management</strong><span>Add, edit, and organize car listings with photos, specs, and pricing.</span></li>
                                    <li><strong>Sales Dashboard</strong><span>Track leads, quotes, and conversions in real time.</span></li>
                                    <li><strong>Customer Management (CRM)</strong><span>Manage customer profiles, inquiries, and follow-ups.</span></li>
                                    <li><strong>Order Tracking</strong><span> Monitor customer orders.</span></li>
                                    <li><strong>Website Integration</strong><span>Get a dedicated branded website to showcase vehicles.</span></li>
                                    <li><strong>Team & Staff Access</strong><span>Role-based access for sales, admin, and service teams.</span></li>
                                    <li><strong>Finance & Documentation Tools</strong><span>Handle financing options, billing, and paperwork efficiently.</span></li>
                                    <li><strong>Analytics & Reporting</strong><span>View sales trends, customer activity, and performance metrics.</span></li>
                                </ul>
                                <h4 style={{ marginTop: '10px' }}>For Customers:</h4>
                                <ul className={styles.featureList}>
                                    <li><strong>Customer Login Portal</strong><span>Secure personal dashboard to track orders and messages.</span></li>
                                    <li><strong>Vehicle Browsing & Search</strong><span>Explore available cars by brand, price, type, or features.</span></li>
                                    <li><strong>Inquiry & Booking System</strong><span>Send questions or reserve a vehicle online.</span></li>
                                    <li><strong>Order History & Status</strong><span>Stay updated on purchases, history, and status.</span></li>
                                    <li><strong>Notifications & Updates</strong><span>Get alerts on deals, bookings, and progress.</span></li>
                                </ul>
                            </article>
                        </div>

                        <div className={styles.groupClients}>
                            <h4>Organizations using the system</h4>
                            <div className={styles.logoGrid}>
                                {carExchangerClients.map((client) => <ClientLogo key={client.id} client={client} />)}
                            </div>
                        </div>
                    </section>

                    <section className={styles.standaloneSection} aria-labelledby="standalone-title">
                        <div className={styles.standaloneHeading}>
                            <div>
                                <p className={styles.groupLabel}>Individual engagements</p>
                                <h3 id="standalone-title">Standalone projects</h3>
                            </div>
                            {/* <p className={styles.sampleNote}>Sample fields are ready for each client’s confirmed project details.</p> */}
                        </div>
                        <div className={styles.standaloneGrid}>
                            {standaloneClients.map((client) => (
                                <article className={styles.standaloneCard} key={client.id}>
                                    <ClientLogo client={client} />
                                    {/* <dl className={styles.projectDetails}>
                                        <div>
                                            <dt>Service</dt>
                                            <dd>Sample: add the service delivered.</dd>
                                        </div>
                                        <div>
                                            <dt>Project details</dt>
                                            <dd>Sample: describe the system, platform, or work completed.</dd>
                                        </div>
                                        <div>
                                            <dt>Outcome</dt>
                                            <dd>Sample: add a verified result or impact.</dd>
                                        </div>
                                    </dl> */}
                                </article>
                            ))}
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
);

export default Clients;